const UC_LIVEBUY_SERVICE = 'Livebuy';
const LIVEBUY_SDK = 'https://sdk.livebuy.io/livebuy-sdk.js';
const CONSENT_COOKIE_NAME = 'COOKIECONSENT';
const CONSENT_COOKIE_VALUE = 1;
const APP_MANDANT = 2003;

class ContentLivebuyWidget extends HTMLElement {

    connectedCallback() {
        this.initLivebuy();
        this.initEventListeners();
    }

    // Fallback für die App, ansonsten wird das Livebuy SDK über das Usercentrics-initialized-event geladen:
    initLivebuy() {
        const mandantId = Number(this.dataset.mandant);
        if (mandantId === APP_MANDANT && this.consentCookieAkzeptiert(CONSENT_COOKIE_NAME, CONSENT_COOKIE_VALUE)) {
            this.addLivebuySDK();
        }
    }

    addLivebuySDK() {
        if (document.querySelector('script[src="' + LIVEBUY_SDK + '"]')) {
            return;
        }
        const script = document.createElement('script');
        script.src = LIVEBUY_SDK;
        script.async = 1;
        this.removeMissingConsentHints();
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    removeMissingConsentHints() {
        document.querySelectorAll('.missing-consent-hint').forEach((elem) => elem.setAttribute("hidden", ""));
    }

    // remove when App implemented Usercentrics:
    consentCookieAkzeptiert(name, value) {
        return document.cookie
            .split(';')
            .filter((item) => item
                .includes(`${name}=${value}`)).length ?
            true :
            false;
    }

    initEventListeners() {
        if(!window.lbEventListener) {
            window.lbEventListener = true;
            window.addEventListener("message", event => {
                if (event.data.action === 'start_show') {
                    this.addCallbackForApp('hideNavigation');
                } else if (event.data.action === 'lb_close_player') {
                    this.addCallbackForApp('showNavigation');
                } else if (event.data.action === 'lb_open_player') {
                    const lbSelectPromotionHelper = document.createElement('div');
                    lbSelectPromotionHelper.id = 'lbSelectPromotionHelper';
                    lbSelectPromotionHelper.setAttribute('promotion-creative', event.data.show.name);
                    document.querySelectorAll('[component="content-livebuy-widget"]')[0].prepend(lbSelectPromotionHelper);
                    let lbSelectPromotionHelperElement = document.querySelector('#lbSelectPromotionHelper');
                    lbSelectPromotionHelperElement.click();
                    lbSelectPromotionHelperElement.remove();
                }
            });
            window.addEventListener('UC_UI_INITIALIZED', () => {
                if (new DataLayerHelper(newDataLayer).get(UC_LIVEBUY_SERVICE)) {
                    this.addLivebuySDK();
                }
            });
            window.addEventListener('ucEvent', (e) => {
                const { detail } = e;
                const { event, action } = detail;
                if (event === "consent_status" && detail[UC_LIVEBUY_SERVICE] !== 'undefined' && action !== 'onInitialPageLoad' && action !== 'onMobileSessionRestore') {
                    location.reload();
                }
            });
        }
    }

    addCallbackForApp(action, param) {
        const callbackApp = createCallbackApp(action, param);
        this.insertAdjacentElement('afterbegin', callbackApp);
    }
}

if (!customElements.get('content-livebuy-widget')) {
    customElements.define('content-livebuy-widget', ContentLivebuyWidget);
}

export function createCallbackApp(action, param) {
    const callbackApp = document.createElement('callback-app');
    callbackApp.setAttribute('callback', action);
    if(param) {
        const { key, value } = param;
        const callbackParam = document.createElement('callback-param');
        callbackParam.setAttribute('key', key);
        callbackParam.setAttribute('value', value);
        callbackApp.appendChild(callbackParam);
    }
    return callbackApp;
}
